import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

export interface HousingUnitBreakdownRecord {
  Place: string;
  place_fips: string;
  year: string | number;
  '1_unit_detached': number;
  '1_unit_attached': number;
  '2_unit_structures': number;
  '3_4_unit_structures': number;
  '5_9_unit_structures': number;
  '10_19_unit_structures': number;
  '20_49_unit_structures': number;
  '50_plus_unit_structures': number;
}

export function useHousingUnitBreakdownData(
  placeName: string | null,
  placeFips: string | null
) {
  const [data, setData] = useState<HousingUnitBreakdownRecord[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!placeFips || !placeName) {
        setData([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const { data: fetchedData, error: fetchError } = await supabase
          .from('acs_bps_metrics_housing_unit_breakdown')
          .select('*')
          .eq('place_fips', placeFips)
          .eq('Place', placeName)
          .order('year', { ascending: false });

        if (fetchError) {
          throw fetchError;
        }

        setData(fetchedData || []);
      } catch (err: any) {
        console.error('Error fetching housing unit breakdown data:', err);
        setError('Failed to load housing unit breakdown data.');
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [placeFips, placeName]);

  return { data, loading, error };
} 